module.exports = __webpack_public_path__ + "static/media/role-based-challenges.9ffb8321.svg";